import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const ModalContentSkeleton = () => {
  return (
    <div>
      <Skeleton height={30} width={'80%'} />
      <Skeleton count={3} width={'100%'} />
      <Skeleton width={'60%'} />
      <Skeleton height={40} marginBottom={20} width={'90%'} />
      <Skeleton height={40} marginTop={20} marginBottom={20} width={'100%'} />
    </div>
  );
};

export default ModalContentSkeleton;